export default {
  refId: "Request #",
  abbr: "Credit", // Claim
  name: "Credit Request", // Claim
  SaveOrderLabel: "Save",
  SavingOrderLabel: "Saving...",
};
